import styles from './hoverline.css'

type HoverlineProps = {
  time: string
  left: number | null | undefined
}

const Hoverline = ({ time, left }: HoverlineProps): JSX.Element => (
  <div className={styles.hoverLine} style={{ left }}>
    <div className={styles.hoverTime}>{time}</div>
  </div>
)

export default Hoverline
